import CONV from "../../semantic-conventions";

export const SEMANTIC_CONVENTIONS_MAP = {
  responseStatus: CONV.HTTP_STATUS_CODE,
  deliveryType: CONV.DELIVERY_TYPE,
};
